<template>
  <div class="mine">
    <!-- 用户信息部分 -->
    <div class="user-info">
      <img class="avatar" :src="avatar" alt="User Avatar">
      <h2 class="username">{{ staff.name }}</h2>
    </div>

    <!-- 导航链接 -->
    <div class="nav-links">
      <router-link to="/settings">
        <van-cell
            title="设置"
            is-link
            icon="setting-o"
            class="nav-item"
            :border="false"
            label="管理"
            value="去设置"
        />
      </router-link>
      <router-link to="/profile">
        <van-cell
            title="个人信息"
            is-link
            icon="user-o"
            class="nav-item"
            :border="false"
            label="编辑"
            value="查看"
        />
      </router-link>
    </div>
  </div>
</template>
<script>

import {mapState} from "vuex";

export default {
  data () {
    return {

    }
  },
  computed: {
    ...mapState('staff', ['staff']),
    ...mapState('token', ['token']),
    avatar () {
      return this.staff.avatar ? this.downloadApi + this.staff.avatar : require('@/assets/avatar.png')
    }
  },
  methods: {
    loading () {

    }
  },
  mounted() {
    this.loading()
  }
}
</script>
<style scoped>
.mine {
  background: #f7f8fc;
  padding: 10px;
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
}

.user-info {
  text-align: center;
  padding: 20px;
}

.avatar {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  object-fit: cover;
}

.username {
  margin-top: 10px;
  font-size: 24px;
  color: #333;
}

.nav-links {
  margin-top: 20px;
  width: 93%; /* 让链接充满整个宽度 */
}

/* Vant UI 样式 */
.nav-item {
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.1);
  margin-bottom: 15px;
  padding: 15px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #333;
}

.nav-item .van-cell__title {
  font-weight: bold;
}

.nav-item .van-cell__icon {
  font-size: 24px;
  margin-right: 10px;
}

.nav-item .van-cell__label,
.nav-item .van-cell__value {
  font-size: 16px;
}
</style>